import { put } from 'redux-saga/effects';
import {
    fetchRiskConfigFail,
    fetchRiskConfigSuccess,
    updateRiskConfigFail,
    updateRiskConfigSuccess
} from './actions';
import { getRiskConfig, updateRiskConfig } from './risks.backend';
import {
    makeChangeErrorPayload,
    makeErrorPayload
} from '../../../../../shared/helpers/payload.helper';
import { setErrorToast } from '../../../../../shared/toast/redux/actions';

export function* fetchRiskConfigSaga(action) {
    const { riskCategory, jurisdictionCode } = action.payload;

    try {
        let response = yield getRiskConfig(riskCategory, jurisdictionCode);
        yield put(fetchRiskConfigSuccess(response.data));
    } catch (error) {
        const formattedError = makeErrorPayload(error);

        yield put(fetchRiskConfigFail(makeErrorPayload(formattedError)));
        yield put(setErrorToast(formattedError));
    }
}

export function* updateRiskConfigSaga(action) {
    const { riskCategory, jurisdictionCode, config } = action.payload;
    try {
        const response = yield updateRiskConfig(
            riskCategory,
            jurisdictionCode,
            config
        );
        yield put(updateRiskConfigSuccess(response.data));
        yield put(fetchRiskConfigSuccess(response.data));
    } catch (error) {
        const formattedError = makeChangeErrorPayload(error);

        yield put(updateRiskConfigFail(formattedError));
        yield put(setErrorToast(formattedError));
    }
}
